export const DEFAULT_NOTIFICATION_SYNC_SETTINGS = Object.freeze({
  enabled: true,
  checkOnAppOpen: true,
  checkWhileUsingApp: true,
  pollingMinutes: 5,
});

export function normalizeNotificationSyncSettings(input) {
  const base = input && typeof input === "object" ? input : {};
  const polling = Number(base.pollingMinutes ?? base.polling_minutes ?? DEFAULT_NOTIFICATION_SYNC_SETTINGS.pollingMinutes);
  const minutes = Number.isFinite(polling) ? Math.max(1, Math.min(60, Math.round(polling))) : DEFAULT_NOTIFICATION_SYNC_SETTINGS.pollingMinutes;
  return {
    enabled: typeof base.enabled === "boolean" ? base.enabled : DEFAULT_NOTIFICATION_SYNC_SETTINGS.enabled,
    checkOnAppOpen: typeof base.checkOnAppOpen === "boolean" ? base.checkOnAppOpen : (typeof base.check_on_app_open === "boolean" ? base.check_on_app_open : DEFAULT_NOTIFICATION_SYNC_SETTINGS.checkOnAppOpen),
    checkWhileUsingApp: typeof base.checkWhileUsingApp === "boolean" ? base.checkWhileUsingApp : (typeof base.check_while_using_app === "boolean" ? base.check_while_using_app : DEFAULT_NOTIFICATION_SYNC_SETTINGS.checkWhileUsingApp),
    pollingMinutes: minutes,
  };
}

export function buildNotificationsSyncSignature({ farmId, session, notificationIds = [] } = {}) {
  const accountId = String(session?.id || "").trim();
  const userId = String(session?.userId || "").trim();
  const username = String(session?.username || "").trim().toLowerCase();
  const ids = Array.from(new Set((Array.isArray(notificationIds) ? notificationIds : []).map((v) => String(v || "").trim()).filter(Boolean))).sort();
  return [String(farmId || "").trim(), accountId, userId, username, ids.join(",")].join("|");
}
